import React from 'react';
import PropTypes from 'prop-types';

import { Element } from 'platform/utilities/scroll';

/**
 * Arranges the form page slots. `FormApp` decides what goes in them.
 */
export default function FormLayout({
  children,
  footer,
  fullWidth = false,
  nav,
  title,
  topContent,
}) {
  return (
    <>
      <div className={fullWidth ? '' : 'row'}>
        <div
          className={
            fullWidth
              ? ''
              : 'usa-width-two-thirds medium-8 columns print-full-width'
          }
        >
          <Element name="topScrollElement" />
          {topContent}
          {title}
          {nav}
          <Element name="topContentElement" />
          {children}
        </div>
      </div>
      {footer}
    </>
  );
}

FormLayout.propTypes = {
  children: PropTypes.node,
  footer: PropTypes.node,
  fullWidth: PropTypes.bool,
  nav: PropTypes.node,
  title: PropTypes.node,
  topContent: PropTypes.node,
};
